import React from 'react'
import { Collection, WhenCollectionIsNotEmpty } from '@morningtrain/react-resources'
import { EmployeeCategoryFilter, SelectedDepartmentFilter } from 'support/filters'
import WhenViewingTemplate from './WhenViewingTemplate'
import ChecklistTemplate from './ChecklistTemplate'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import ChecklistTemplateListView from 'pages/app/checklists/ChecklistTemplateListView'
import WhenIndexingChecklistTemplates from 'pages/app/checklists/WhenIndexingChecklistTemplates'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Link } from '@morningtrain/react-navigation'
import * as Icons from 'ui/icons'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import CreateChecklistTemplateSmartview from 'pages/app/checklists/smartviews/CreateChecklistTemplateSmartview'
import EditChecklistTemplateSmartview from 'pages/app/checklists/smartviews/EditChecklistTemplateSmartview'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'

export default function Templates () {
  return (
    <AdminPageWithSmartview slideInSmartview>
      <Translator namespace='checklists'>

        <UI.CardGroup>

          <Collection resourceName='checklists.checklist_templates'>
            <MountSmartviewOnSelection smartview={<EditChecklistTemplateSmartview />} replace={false} resetOnDeselect />

            <UI.PageHeader title={<TranslatedTitle name='checklist_templates' />}>
              <UI.ButtonWrap>
                <EmployeeCategoryFilter defaultValue={null} allowNull />
                <Link route='app.checklists'>
                  <UI.Button>
                    <Icons.ArrowLeft className='mr-2' />
                    <span><Translation name='checklists.actions.back_to_overview' /></span>
                  </UI.Button>
                </Link>
                <MountSmartviewOnClick smartview={<CreateChecklistTemplateSmartview />} replace={false}>
                  <UI.Button>
                    <Translation name='actions.create_template' />
                  </UI.Button>
                </MountSmartviewOnClick>
              </UI.ButtonWrap>
            </UI.PageHeader>

            <SelectedDepartmentFilter />

            <ChecklistTemplateListView />
          </Collection>

        </UI.CardGroup>
      </Translator>
    </AdminPageWithSmartview>
  )
}
